import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=1ec19e3a&scoped=true"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"
import style0 from "./Avatar.vue?vue&type=style&index=0&id=1ec19e3a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec19e3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ec19e3a')) {
      api.createRecord('1ec19e3a', component.options)
    } else {
      api.reload('1ec19e3a', component.options)
    }
    module.hot.accept("./Avatar.vue?vue&type=template&id=1ec19e3a&scoped=true", function () {
      api.rerender('1ec19e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/Avatar.vue"
export default component.exports